<template>
  <div class="d-flex align-start justify-start flex-wrap">
    <div
      v-for="app in essentialsData"
      :key="app.id"
      class="mt-3 mr-3 mb-3"
      style="width: 80px"
    >
      <a
        :href="app.url"
        style="text-decoration: none"
      >
        <div class="d-flex flex-column align-center">
          <svg :class="'icon ' + app.iconClass">
            <use v-bind="{ 'xlink:href': app.xlinkHref }" />
          </svg>
          <span class="appTitle">{{ app.title }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Essentials",
    props: {
      essentialsData: {
        type: Array,
        default: null
      }
    },
    data() {
      return {
        iconToClass: window.iconToClass
      }
    },
    created() {
      for (let data of this.essentialsData) {
        let iconKey = data.icon;
        if (iconKey in this.iconToClass) {
          data['iconClass'] = this.iconToClass[data.icon];
          if (document.getElementById(data.icon.substring(3))) {
            data.icon = data.icon.substring(3);
          }
          data['xlinkHref'] = '#' + data.icon;
        }
      }
    },
  }
</script>

<style scoped>
  svg {
    padding-top: 2px;
    padding-left: 1px;
  }
  .my-essentials {
    width: 18.9375rem;
    padding-bottom: 50px;
  }

  .icon {
    width: 3.875rem;
    height: 3.875rem;
    border-radius: 7px;
  }

  .appTitle {
    width: 68px;
    display: block;
    color: #525252;
    line-height: 1.23;
    font-family: Arial;
    font-size: 13px;
    text-align: center;
    margin-top: 8px;
  }
</style>